import { asyncClear } from './creators';
import { getAsyncStatus } from '../selectors';

const asyncCancel = keyPath => (dispatch, getState) => {
	const asyncStatus = getAsyncStatus(getState(), keyPath).toJS();

	// cancel the request if a cancellation source is present
	if (asyncStatus.cancellationSource && asyncStatus.isRequesting) {
		asyncStatus.cancellationSource.cancel('axios cancellation');
	}

	// clear this status
	dispatch(asyncClear([keyPath]));
};

export default asyncCancel;
